import CONFIG from '@/api/config';
import useFetchGroup from '@/api/hooks/useFetchGroup';
import { useMutateApi } from '@/api/hooks/useMutateApi';
import usePageData from '@/api/hooks/usePageData';
import AccordionPanel from '@/components/AccordionItem';
import GlobeLoading from '@/components/GlobeLoading';
import Product from '@/components/ProductCard';
import SliderItem from '@/components/ProductPageSliderItem';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';


const Products: React.FC = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [isProductsLoaded, setIsProductsLoaded] = useState<boolean>(false);
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const [currentCategory, setCurrentCategory] = useState<any>();
  const params = useParams<{ catslug: string }>();
  const navigate = useNavigate();
  const location = useLocation();
 
  const {
    data: pageData,
    page,
    localization,
    isLoading
  } = usePageData();
  const {
    _get
  } = useMutateApi({
    Service: 'CMS_PROC',
  });


  useEffect(() => {
    if (pageData) {
      if (currentCategory?.slug !== params.catslug) {
        setCurrentCategory(
          pageData?.Categories?.find((category: any) => category.slug === params.catslug),
        );
      }
    }
  }, [pageData]);

  useEffect(() => {
    if (!params.catslug && pageData?.Categories?.length > 0) {
      navigate((location.pathname + '/' + pageData?.Categories[1]?.slug).replace(/\/+/g, '/'));
    }
  }, [params, pageData?.Categories]);


  useEffect(() => {
    if (currentCategory) {
      setIsProductsLoaded(false);
      _get('/v1/page/data/products/' + currentCategory?._id + "?response=json").then((response) => {
        setProducts(response.data?.Products || []);
      })
        .finally(() => {
          setIsProductsLoaded(true);
        });
    }
  }, [currentCategory]);


  useEffect(() => {
    if (products.length === 0 && !isProductsLoaded) return;

    jQuery('#shop-slider').owlCarousel({
      singleItem: true,
      pagination: true,
    });
  }, [isProductsLoaded]);

  const [activePanel, setActivePanel] = useState<number | null>(0);
  const handlePanelClick = (index: number) => {
    setActivePanel(activePanel === index ? null : index);
  }

  return (
    <div>
      {
        (products && isProductsLoaded && products.length > 0) && (
          <Helmet>
            <title>
              {currentCategory?.title}
            </title>
          </Helmet>
        )
      }
      <GlobeLoading isLoading={isLoading} />
      <section className="sub-page-banner shop-banner">
        {(products && isProductsLoaded && products.length > 0) && (
          <div id="shop-slider" className="owl-carousel">
            {products.map((product: any, index: any) => (
              <SliderItem
                id={product._id}
                key={index + 'slider' + product._id}
                title={product.title}
                description={product.description}
                features={[]}
                imageUrl={product.image}
                groupSefURL={""}
                detailsTitle={
                  localization?.dict["slider.btn"]?.value
                }
              />
            ))}
          </div>
        )}

      </section>

      <div id="sub-page-content" className="clearfix">
        <div className="container">
          <div className="row">
            <div className="col-md-8 clearfix">
              {currentCategory ? (
                <h2 className="bordered light">
                  <span>{currentCategory?.title}</span>
                </h2>
              ) : (
                <h2
                  className="bordered light"
                  dangerouslySetInnerHTML={{
                    __html: '',
                  }}
                ></h2>
              )}

              <div className="products">
                {(products.length > 0 ? products : products).map((product: any, index: any) => (
                  <Product
                    id={product._id}
                    key={index}
                    image={product.image}
                    title={product.title}
                    content={product.content}
                    category={product.category}
                    sef_url={
                      page?.slug?.replace(":cat-slug", currentCategory?.slug) + '/' + product.sef_url
                    }
                  />
                ))}
              </div>
            </div>

            <aside className="col-md-4">
              <div className="sidebar-widget clearfix">
                <h2
                  className="bordered light"

                >
                  {localization?.dict["categories"]?.value}
                </h2>
                <ul className="tags">
                  {pageData?.Categories?.map((category: any, index: any) => (
                    <li key={index}>
                      <Link
                        className={clsx('link', {
                          active: currentCategory?.title === category.title,
                        })}
                        to={page?.slug?.replace(":cat-slug", category.slug)}

                      >
                        {category.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="sidebar-widget clearfix">
                <h2
                  className="bordered light"
                  dangerouslySetInnerHTML={{
                    __html: pageData?.populated?.ProductsPage?.records?.find(
                      (record: any) => record.title === 'general_look',
                    )?.content,
                  }}
                ></h2>


                <div className="panel-group" id="accordion">
                  {pageData?.Accordion?.map((item: any, index: number) => (
                    <AccordionPanel
                      key={index}
                      id={index}
                      title={item.title}
                      content={item.content}
                      isOpen={activePanel === index}
                      onClick={handlePanelClick}
                    />
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Products;
